export default {
    getFrame: (frameName) => {
        let iframe = window.document.querySelector(`iframe[name='${frameName}']`);
        if (iframe)
            return iframe.contentWindow;
        else
            return window.frames[frameName];
    },
    replaceAll: (str, find, replace) => {
        return str.replace(new RegExp(find, "g"), replace);
    },
};
